import { useEffect, useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { Text, ColorV2, Button } from "@adoptaunabuelo/react-components";
import VideoModal from "../../../components/modal/VideoModal";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import { Play } from "lucide-react";

const HeaderContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;
const Section = styled.div<{ $backgroundImage: any }>`
	position: relative;
	display: flex;
	flex-direction: row;
	height: calc(var(--doc-height) - var(--nav-bar-height));
	${(props) => media.lessThan("medium")`
       	background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		background-position-y: center;
		background-image: url(${props.$backgroundImage});
		margin: 0px -24px;
		padding: 24px;
		height: 70vh;
    `}
`;
const SectionMobile = styled.div`
	position: relative;
	display: none;
	flex-direction: column;
	margin: 4px -24px 0px;
	${media.lessThan("medium")`
        display: flex;
    `}
`;
const DataView = styled.div`
	display: flex;
	flex-direction: column;
	width: 480px;
	margin-top: 64px;
	z-index: 1;
	${media.lessThan("medium")`
		width: unset;
        padding: 32px 0px;
        margin-top: 0px;
    `}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
`;
const Title = styled(Text)`
	font-weight: 600 !important;
	${media.lessThan("small")`
        font-size: 26px !important;
	`}
`;
const TitleSpan = styled.span`
	background-color: white;
	padding: 0px 8px;
`;

const Header = (props: Props) => {
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const [play, setPlay] = useState(false);

	useEffect(() => {
		if (props.utmSource) {
			if (props.utmSource === "email" || props.utmSource === "whatsapp-sb") {
				const timer = setTimeout(() => {
					setPlay(true);
				}, 1000);
				return () => clearTimeout(timer);
			}
		}
	}, [props.utmSource]);

	const onVideoEnd = () => {
		setPlay(false);
	};

	return (
		<>
			<VideoModal
				isVisible={play}
				url={"https://youtube.com/shorts/Tu7wJvr0vfM"}
				onFinish={onVideoEnd}
				onClose={() => setPlay(false)}
			/>
			<HeaderContainer>
				<SectionMobile>{props.children}</SectionMobile>
				<Section
					$backgroundImage={require("../../../assets/images/background/donation.webp")}
				>
					<DataView>
						<Title
							type="h2"
							style={{
								marginBottom: isMobile ? 24 : 48,
							}}
						>
							<TitleSpan>
								<span style={{ color: ColorV2.text.primary }}>
									Necesitamos tu ayuda
									<br />
								</span>{" "}
							</TitleSpan>
							<TitleSpan>
								para seguir
								<br />
							</TitleSpan>
							<TitleSpan>
								acompañando a<br />
							</TitleSpan>
							<TitleSpan>personas mayores</TitleSpan>
						</Title>
						<Row>
							<Button
								style={{
									background: "rgba(0, 29, 61, 0.24)",
									backdropFilter: "blur(20px)",
									color: "white",
									height: isMobile ? 48 : 56,
									padding: isMobile ? "0px 16px" : "0px 24px",
								}}
								icon={
									<Play
										height={18}
										width={18}
										fill={"white"}
										color={"white"}
									/>
								}
								onClick={() => setPlay(true)}
							>
								Ver video
							</Button>
						</Row>
					</DataView>
				</Section>
			</HeaderContainer>
		</>
	);
};
export default Header;
export interface Props {
	children?: React.ReactNode;
	utmSource?: string;
}
